import '~/components/shared/tracking/globalTracking';
import '~/components/shared/globalFooter';
import { initializeArticleSlider } from '~/components/shared/articles-slider';
import addServiceCardListeners from '~/components/b2c/clearprice/components/clearprice_service_cards';
import { initializePriceSearchForm } from '~/components/b2c/clearprice/components/clearprice_zip_search';
import '~/components/shared/controllers/showMoreController';
import '~/components/shared/controllers/expansionController';
import '~/components/shared/controllers/modalController';
import '~/components/shared/controllers/scrollToController';
import '~/components/shared/controllers/scrollSpyController';
import '~/components/shared/navigation';
import tippy, { followCursor } from 'tippy.js';

const bodyId = document.body.id.replaceAll('_', '-');

const dynamicLoadTree = {
  'b2c-clearprice-landing-page-index': () =>
    import('~/components/b2c/clearprice/pages/landingPage'),
  'b2c-clearprice-markets-state': () =>
    import('~/components/b2c/clearprice/pages/market'),
  'b2c-clearprice-markets-city': () =>
    import('~/components/b2c/clearprice/pages/market'),
  'b2c-clearprice-services-show': () =>
    import('~/components/b2c/clearprice/pages/services'),
};

if (typeof dynamicLoadTree[bodyId] !== 'undefined') {
  dynamicLoadTree[bodyId]();
}

// set up article slider
const articleSliderSelector = '.clearprice-featured-articles.glide';
const articleSliderOptions = {
  type: 'carousel',
  gap: 30,
  slideWidth: 400,
  perView: 3,
  peek: {
    before: 15,
    after: 40,
  },
  breakpoints: {
    425: {
      slideWidth: 285,
    },
  },
};
initializeArticleSlider(articleSliderSelector, articleSliderOptions);

// add listeners to service cards
const form = initializePriceSearchForm();
if (form) {
  addServiceCardListeners(form);
}

tippy('svg.chloropeth__map g[data-tooltip-template]', {
  content(reference) {
    return reference.dataset.tooltipTemplate;
  },
  followCursor: true,
  allowHTML: true,
  duration: 100,
  plugins: [followCursor],
});
